import React, { useState, useEffect } from 'react'
import Layout from '../components/Layout'
import api from '../services/api'
import { useModal } from '../components/Modal'

export default function ClerkPage() {
  const { showAlert, ModalComponents } = useModal()
  const [contracts, setContracts] = useState([])
  const [loading, setLoading] = useState(true)
  const [summary, setSummary] = useState({ total: 0, signed: 0, pending: 0 })
  const [selectedQR, setSelectedQR] = useState(null)
  const [qrData, setQrData] = useState(null)
  const [loadingQR, setLoadingQR] = useState(false)
  const [copied, setCopied] = useState(false)

  useEffect(() => { fetchContracts() }, [])

  const fetchContracts = async () => {
    try {
      setLoading(true)
      const res = await api.get('/contracts/clerk')
      if (res.data.success) {
        setContracts(res.data.data)
        const total = res.data.data.length
        const signed = res.data.data.filter(c => ['signed','witness1_signed','approved','completed'].includes(c.status)).length
        const pending = res.data.data.filter(c => c.status === 'pending').length
        setSummary({ total, signed, pending })
      }
    } catch (err) { console.error(err) }
    finally { setLoading(false) }
  }

const handleShowQR = async (contract) => {
  setQrData(null)
  setCopied(false)
  setSelectedQR(contract)
  setLoadingQR(true)

  try {
    const res = await api.get(`/contracts/${contract.id}/qr`)

    if (!res.data.success || !res.data.qrCode) {
      throw new Error(res.data.message || 'ไม่พบข้อมูล QR Code')
    }

    setQrData(res.data)

    if (res.data.expires_at) {
      setContracts(previous => previous.map(item =>
        item.id === contract.id
          ? { ...item, token_expires_at: res.data.expires_at }
          : item
      ))
    }
  } catch (err) {
    setSelectedQR(null)
    showAlert(
      'error',
      'เปิด QR Code ไม่สำเร็จ',
      err.response?.data?.message || err.message
    )
  } finally {
    setLoadingQR(false)
  }
}

  const handleSaveQR = () => {
    if (!qrData) return
    const a = document.createElement('a')
    a.href = qrData.qrCode
    a.download = `qr_${selectedQR.contract_no.replace(/\//g, '_')}.png`
    document.body.appendChild(a)
    a.click()
    document.body.removeChild(a)
  }

  const handleCopyLink = () => {
    if (!qrData) return
    try {
      const textArea = document.createElement('textarea')
      textArea.value = qrData.signUrl
      textArea.style.position = 'fixed'
      textArea.style.opacity = '0'
      document.body.appendChild(textArea)
      textArea.focus()
      textArea.select()
      document.execCommand('copy')
      document.body.removeChild(textArea)
      setCopied(true)
      setTimeout(() => setCopied(false), 2000)
    } catch (err) { showAlert('warning', 'ไม่สามารถ Copy ได้', 'กรุณา Copy Link ด้านล่างเองครับ') }
  }


  const statusConfig = {
    draft: {label:'รอ HR ส่งอีเมล',color:'#64748b',bg:'#f1f5f9'},
    pending:   { label: 'รอพนักงานเซ็น', color: '#f59e0b', bg: '#fef9c3' },
    signed:    { label: 'เซ็นแล้ว',       color: '#3b82f6', bg: '#eff6ff' },
    witness1_signed: { label: 'รอพยาน 2', color: '#2563c5', bg: '#eff6ff' },
    approved:  { label: 'รอนายกลงนาม',   color: '#8b5cf6', bg: '#f5f3ff' },
    completed: { label: 'เสร็จสมบูรณ์',  color: '#22c55e', bg: '#f0fdf4' },
    rejected: { label: 'ยกเลิกสัญญา', color: '#ef4444', bg: '#fef2f2' },
    cancelled: { label: 'ยกเลิกสัญญา', color: '#ef4444', bg: '#fef2f2' },
  }

  const statCards = [
    { label: 'สัญญาทั้งหมด', value: summary.total, icon: 'ti-files', color: '#075dcc', bg: '#eff6ff' },
    { label: 'รอเซ็น', value: summary.pending, icon: 'ti-clock-hour-4', color: '#f59e0b', bg: '#fef9c3' },
    { label: 'ดำเนินการแล้ว', value: summary.signed, icon: 'ti-circle-check', color: '#22c55e', bg: '#f0fdf4' },
  ]

  return (
    <Layout>
      <ModalComponents />
      <div className="ice-list-page" style={{ maxWidth: '1200px', margin: '0 auto' }}>

        {/* Header */}
        <div style={{ marginBottom: '24px' }}>
          <h1 style={{ fontSize: '20px', fontWeight: '500', color: '#0f172a' }}>ติดตามสัญญา</h1>
          <p style={{ fontSize: '13px', color: '#94a3b8', marginTop: '4px' }}>สัญญาพนักงานในกองที่ดูแล</p>
        </div>

        {/* Stats */}
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '14px', marginBottom: '24px' }}>
          {statCards.map((s, i) => (
            <div key={i} style={{ background: 'white', borderRadius: '14px', border: '0.5px solid #e2e8f0', padding: '18px', position: 'relative', overflow: 'hidden' }}>
              <div style={{ position: 'absolute', top: 0, left: 0, right: 0, height: '3px', background: s.color, borderRadius: '14px 14px 0 0' }} />
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '12px' }}>
                <div style={{ width: '38px', height: '38px', borderRadius: '10px', background: s.bg, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                  <i className={`ti ${s.icon}`} style={{ fontSize: '20px', color: s.color }} />
                </div>
              </div>
              <p style={{ fontSize: '28px', fontWeight: '500', color: '#0f172a' }}>{s.value}</p>
              <p style={{ fontSize: '12px', color: '#94a3b8', marginTop: '2px' }}>{s.label}</p>
            </div>
          ))}
        </div>

        {/* Table */}
        <div style={{ background: 'white', borderRadius: '14px', border: '0.5px solid #e2e8f0', overflow: 'hidden' }}>
          {loading ? (
            <div style={{ textAlign: 'center', padding: '60px', color: '#94a3b8', fontSize: '13px' }}>กำลังโหลด...</div>
          ) : contracts.length === 0 ? (
            <div style={{ textAlign: 'center', padding: '60px', color: '#94a3b8', fontSize: '13px' }}>ไม่มีสัญญาในกองของท่าน</div>
          ) : (
            <div style={{ overflowX: 'auto' }}>
              <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                <thead>
                  <tr style={{ background: '#f8fafc' }}>
                    {['เลขสัญญา', 'พนักงาน', 'กองงาน', 'ประเภท', 'สถานะ', 'จัดการ'].map(h => (
                      <th key={h} style={{ textAlign: 'left', padding: '10px 16px', fontSize: '11px', color: '#94a3b8', fontWeight: '500' }}>{h}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {contracts.map(c => {
                    const s = c.status === 'ended' ? {label:'สิ้นสุดก่อนกำหนด',color:'#ef4444',bg:'#fef2f2'}
                      : c.status === 'completed' && c.termination_date ? {label:'กำหนดสิ้นสุดล่วงหน้า',color:'#2563eb',bg:'#eff6ff'}
                      : statusConfig[c.status] || { label: c.status, color: '#64748b', bg: '#f1f5f9' }
                    const days = c.token_expires_at ? Math.ceil((new Date(c.token_expires_at)-new Date())/86400000) : null
                    const isOverdue = days !== null && days <= 0
                    return (
                      <tr key={c.id} style={{ borderTop: '0.5px solid #f1f5f9' }}
                        onMouseEnter={e => e.currentTarget.style.background = '#f8fafc'}
                        onMouseLeave={e => e.currentTarget.style.background = 'transparent'}>
                        <td style={{ padding: '12px 16px', fontSize: '13px', fontWeight: '500', color: '#0f172a' }}>{c.contract_no}</td>
                        <td style={{ padding: '12px 16px', fontSize: '13px', color: '#334155' }}>{c.prefix}{c.first_name} {c.last_name}</td>
                        <td style={{ padding: '12px 16px', fontSize: '12px', color: '#94a3b8' }}>{c.division_name || '-'}</td>
                        <td style={{ padding: '12px 16px' }}>
                          <span style={{ display: 'inline-flex', padding: '3px 10px', borderRadius: '999px', fontSize: '11px', background: '#eff6ff', color: '#075dcc' }}>{c.emp_type}</span>
                        </td>
                        <td style={{ padding: '12px 16px' }}>
                          <span style={{ display: 'inline-flex', padding: '3px 10px', borderRadius: '999px', fontSize: '11px', fontWeight: '500', color: s.color, background: s.bg }}>{s.label}</span>
                        </td>
                        <td style={{ padding: '12px 16px' }}>
                          {c.status === 'pending' && (
                            <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
                              <button onClick={() => handleShowQR(c)}
                                style={{ padding: '6px 14px', background: '#075dcc', color: 'white', border: 'none', borderRadius: '8px', fontSize: '12px', fontWeight: '500', cursor: 'pointer' }}>
                                แสดง QR
                              </button>
                              <span style={{ fontSize: '11px', fontWeight: '500', color: isOverdue ? '#ef4444' : '#f97316', textAlign: 'center' }}>
                                {days === null || !Number.isFinite(days)
  ? 'ยังไม่มีวันหมดอายุลิงก์'
  : isOverdue
    ? `⚠️ เกิน ${Math.abs(days)} วัน`
    : `⏱ เหลือ ${days} วัน`}
                              </span>
                            </div>
                          )}
                        </td>
                      </tr>
                    )
                  })}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </div>

      {/* QR Modal */}
      {selectedQR && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 50, padding: '16px' }}>
          <div style={{ background: 'white', borderRadius: '16px', width: '100%', maxWidth: '360px' }}>
            <div style={{ padding: '16px 20px', borderBottom: '0.5px solid #f1f5f9', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
              <div>
                <p style={{ fontSize: '14px', fontWeight: '500', color: '#0f172a' }}>QR Code เซ็นสัญญา</p>
                <p style={{ fontSize: '12px', color: '#94a3b8', marginTop: '2px' }}>{selectedQR.prefix}{selectedQR.first_name} {selectedQR.last_name}</p>
              </div>
              <button onClick={() => { setSelectedQR(null); setQrData(null) }}
                style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#94a3b8', fontSize: '20px' }}>×</button>
            </div>

            <div style={{ padding: '20px', textAlign: 'center' }}>
              {loadingQR ? (
                <div style={{ padding: '40px', color: '#94a3b8', fontSize: '13px' }}>กำลังโหลด QR Code...</div>
              ) : qrData ? (
                <>
                  <div style={{ background: '#f8fafc', borderRadius: '12px', padding: '12px', marginBottom: '12px', display: 'inline-block' }}>
                    <img src={qrData.qrCode} alt="QR Code" style={{ width: '180px', height: '180px', display: 'block' }} />
                  </div>
                  <p style={{ fontSize: '11px', color: '#94a3b8', marginBottom: '16px', wordBreak: 'break-all', padding: '0 4px' }}>{qrData.signUrl}</p>



                  <div style={{ display: 'flex', gap: '8px' }}>
                    <button onClick={handleSaveQR}
                      style={{ flex: 1, padding: '9px', background: '#075dcc', color: 'white', border: 'none', borderRadius: '10px', fontSize: '12px', fontWeight: '500', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '6px' }}>
                      <i className="ti ti-download" style={{ fontSize: '14px' }} />
                      Save รูป
                    </button>
                    <button onClick={handleCopyLink}
                      style={{ flex: 1, padding: '9px', background: copied ? '#22c55e' : 'white', color: copied ? 'white' : '#64748b', border: '0.5px solid #e2e8f0', borderRadius: '10px', fontSize: '12px', fontWeight: '500', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '6px' }}>
                      <i className={`ti ${copied ? 'ti-check' : 'ti-copy'}`} style={{ fontSize: '14px' }} />
                      {copied ? 'Copied!' : 'Copy Link'}
                    </button>
                  </div>
                </>
              ) : null}
            </div>
          </div>
        </div>
      )}
    </Layout>
  )
}
